import { getFunI18n } from './i18n'

export default {
    props: {
        parentLang: {
            type: String,
            default: 'en',
        },
    },
    computed: {
        t() {
            return getFunI18n(this.parentLang);
        },
    },
};



// WEBPACK FOOTER //
// ./src/pages/fun/logic.js